import { render, staticRenderFns } from "./LoadingChatList.vue?vue&type=template&id=76df384f&"
import script from "./LoadingChatList.vue?vue&type=script&lang=ts&"
export * from "./LoadingChatList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports